import { createSlice } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ErrorMessage, Removed, SuccessMessage } from "src/constants/Constant";



interface ApiErrorMessage {
    status: boolean,
    message: string
}
interface FetchUser {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    countryCode?: any,
    countryShortName?: any,
    role: string,
    profileImgUrl?: any,
    id?: number

}

interface FetchProfileImage {
    profileImgUrl?: any,
}


export interface UserState {

    users: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: {
            count: string,
            rows: FetchUser[]
        }
    }
    GetAddEditUser: {
        status: boolean,
        message: string,
        isloading: boolean,
        data: {
            count: string,
            rows: FetchUser[]
        }
        error: boolean
    },
    GetUsers: {
        status: boolean,
        isloading: boolean,
        message: string,
        data: {
            count: string,
            rows: FetchUser[]
        },
        error: boolean
    },
    createUser: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: {
            count: string,
            rows: FetchUser
        }
    },
    Adduserinfo: {
        title: string,
        action: string,
        data: FetchUser,
        id: string
    };
    editUserButton: {
        title: string,
        action: string,
        data: FetchUser,
        id: string
    };
    pagination: {
        max: string | number,
        limit: any,
        currentPage: any,
        data: {
            count: string,
            rows: Array<FetchUser>
        }
    },
    AlertMessageState: {
        show: boolean;
        type: string;
        module?: string;
        message: string;
        showModal: boolean;
    },
    ErrorMessage: {
        data: ApiErrorMessage,
        error: boolean,
    },
    SearchMsg: {
        page: number,
        searchText: string
    },
    usersDelete: {
        isloading: boolean,
        status: boolean,
        message: string
    },
    ErrorUpdate: ApiErrorMessage,
    username: string,
    profileImage: {
        isloading: boolean,
        data: FetchProfileImage[],
    },
    ProfileImageStatus: {
        type: string,
        action: string,
        data?: any
    },

}
const initialState: UserState = {

    users: {
        isloading: true,
        status: false,
        message: '',
        data: {
            count: '',
            rows: [],
        },
    },
    GetAddEditUser: {
        status: false,
        isloading: false,
        message: '',
        data: {
            count: '',
            rows: []
        },
        error: false
    },
    GetUsers: {
        status: false,
        isloading: false,
        message: '',
        data: {
            count: '',
            rows: []
        },
        error: false
    },

    AlertMessageState: null,
    createUser: {
        isloading: false,
        status: false,
        message: '',
        data: {
            count: '',
            rows: null
        },
    },
    Adduserinfo: {
        title: '',
        action: '',
        data: null,
        id: ''
    },
    editUserButton: {
        title: '',
        action: '',
        data: null,
        id: ''
    },
    pagination: {
        max: 1,
        limit: 10,
        currentPage: 0,
        data: {
            count: '',
            rows: [],
        },
    },
    ErrorMessage: {
        data: null,
        error: false
    },
    SearchMsg: {
        page: 0,
        searchText: null
    },
    usersDelete: {
        isloading: false,
        status: false,
        message: ''
    },
    ErrorUpdate: null,
    username: "",
    profileImage: {
        isloading: false,
        data: null,
    },
    ProfileImageStatus: {
        type: '',
        action: '',
        data: null
    },
}
const Slice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        addUser: (state, action) => {
            state.users = action.payload
        },
        usersReceived: (state, action) => {
            state.users = action.payload;
            state.users = {
                ...state.users,
                isloading: false
            }
        },
        usersDataLoading: (state) => {
            state.users.isloading = true;
        },
        usersRequestFailed: (state, action) => {
            state.users = action.payload;
        },
        GetAddEditUserLoading(state) {
            state.GetAddEditUser = {
                ...state.GetAddEditUser,
                status: false,
                isloading: true,
                error: false
            };
        },
        GetAddEditUser(state, action) {
            state.GetAddEditUser = action.payload
        },
        GetUserInfoLoading(state) {
            state.GetUsers = {
                ...state.GetUsers,
                status: false,
                isloading: true,
                error: false
            };
        },
        GetUserInfo(state, action) {
            state.GetUsers = action.payload;
            state.GetUsers.isloading = false;
        },
        GetUserErrorInfo(state, action) {
            state.GetUsers = {
                ...state.GetUsers,
                status: false,
                data: action.payload,
                error: true,
            };
        },
        GetUserReset(state) {
            state.GetUsers = {
                ...state.GetUsers,
                status: false,
                data: null,
                error: true,
            }
        },
        GetAddEditUserError(state, action) {
            state.GetAddEditUser = {
                ...state.GetAddEditUser,
                status: false,
                data: action.payload,
                error: true,
            };
        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
                show: true,
                module: action.payload.module,
                type: action.payload.type,
                message: action.payload.message,
                showModal: action.payload.showModal,
            };
        },

        createUserLoading: (state) => {
            state.createUser = {
                ...state.createUser,
                isloading: true,
                status: false
            };
        },
        createUserInfo: (state, action) => {
            state.createUser = action.payload;
            state.createUser.isloading = false;
        },
        createUserErrorInfo: (state, action) => {
            state.createUser.status = false;
        },
        createUserProfileErrorInfo: (state, action) => {
            state.createUser = {
                ...state.createUser,
                isloading: false,
                data: action.payload
            }
        },
        clearAlertMessage(state) {
            state.AlertMessageState = {
                show: false,
                type: null,
                message: null,
                showModal: false,
            };
        },

        clearUserData(state) {
            state.GetAddEditUser.data = null;
            state.createUser = null;
            state.AlertMessageState = null
        },
        AddUserInfoData(state, action) {
            state.Adduserinfo = action.payload;
        },
        setCurrentPage(state, action) {
            state.pagination.currentPage = action.payload;
        },
        paginationItem(state, action) {
            state.pagination = action.payload;
            state.pagination.limit = 10
        },
        searchItem(state, action) {
            state.users = action.payload;
        },
        searchSatus(state, action) {
            state.SearchMsg = {
                searchText: action.payload.searchText,
                page: action.payload.page,
            };
        },
        clearsearchSatus(state) {
            state.SearchMsg = {
                searchText: null,
                page: 0,
            };
        },
        ErrorMessage(state, action) {
            state.ErrorMessage = {
                data: action.payload,
                error: true
            }


        },
        ErrorUpdate(state, action) {
            state.ErrorUpdate = action.payload
        },
        updateUserName(state, action) {
            state.username = action.payload
        },
        updateUserNameReset(state) {
            state.username = null
        },
        deleteInfo(state, action) {
            state.usersDelete = action.payload
        },
        selectProfileImage(state, action) {
            state.profileImage = {
                ...state.profileImage,
                isloading: false,
                data: action.payload
            }
        },
        selectProfileImageStatus: (state, action) => {
            
            state.ProfileImageStatus = {
                
                action: action.payload.action,
                type: action.payload.type,
                data: action.payload.data
            }
        },
    }
})

// Fetch Limit Users
export const FetchUserData = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.usersDataLoading())
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/users?page=${data}`)
        dispatch(Slice.actions.usersReceived(res.data))


    } catch (err) {
        dispatch(Slice.actions.usersRequestFailed(err))
        dispatch(Slice.actions.ErrorMessage(err));
    }
}

// Fetch All Users for pagination
export const FetchAllUser = () => async (dispatch: any) => {
    dispatch(Slice.actions.usersDataLoading())
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/users?size=all`)
        dispatch(Slice.actions.paginationItem(res.data))

    } catch (err) {
        dispatch(Slice.actions.usersRequestFailed(err))
        dispatch(Slice.actions.ErrorMessage(err));
    }
}

// Create Users
export const CreateUserData = (DatQ: any) => async (dispatch: any) => {
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/users`, DatQ);
        dispatch(Slice.actions.createUserInfo(res.data))
        dispatch(Slice.actions.showAlertMessage({
            message: res.data.message,
            type: SuccessMessage
        }));
    } catch (error) {

        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
        dispatch(Slice.actions.createUserErrorInfo(error));
    }
}

// get Users
export const getUser = (DatQ1: any) => async (dispatch: any) => {
    dispatch(Slice.actions.GetUserInfoLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/users?id=${DatQ1}`)
        dispatch(Slice.actions.GetUserInfo(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetUserErrorInfo(err))
    }
}

// Update Users
export const updateUser = (DatQ1: any, DatQ2: any, isSame: boolean) => async (dispatch: any) => {

    try {
        const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/users/${DatQ1}`, DatQ2);
        dispatch(Slice.actions.createUserInfo(res.data));
        if (isSame) {
            dispatch(Slice.actions.updateUserName(`${DatQ2.firstName} ${DatQ2.lastName}`))
        }
        dispatch(Slice.actions.showAlertMessage({
            message: res.data.message,
            type: SuccessMessage
        }));
    } catch (err) {
        dispatch(Slice.actions.showAlertMessage({
            message: err.message,
            type: ErrorMessage
        }));
        dispatch(Slice.actions.createUserErrorInfo(err));

    }
}

//Update Profile
export const updateProfile = (id: any, data: any, isSame) => async (dispatch: any) => {
    dispatch(Slice.actions.createUserLoading())
    const firstName = data.get('firstName');
    const lastName = data.get('lastName');
    try {
        const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/updateProfile/${id}`, data);
        dispatch(Slice.actions.createUserInfo(response.data));
        if (isSame) {
            dispatch(Slice.actions.updateUserName(`${firstName} ${lastName}`))
        }
        dispatch(Slice.actions.showAlertMessage({
            module: 'userProfile',
            message: response.data.message,
            type: SuccessMessage
        }));
    }
    catch (err) {
        dispatch(Slice.actions.showAlertMessage({
            module: 'userProfile',
            message: err.message,
            type: ErrorMessage
        }));
        dispatch(Slice.actions.createUserProfileErrorInfo(err));
    }
};

// Search Results
export const SearchUsers = (dataq: any, page: any) => async (dispatch: any) => {
    dispatch(Slice.actions.usersDataLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/users?username=${dataq.trim()}&page=${page}`)
        dispatch(Slice.actions.usersReceived(res.data))

    } catch (err) {
        dispatch(Slice.actions.usersRequestFailed(err))
        dispatch(Slice.actions.ErrorMessage(err));
    }
}

// Delete Users
export const deleteUser = (DatQ1: any) => async (dispatch: any) => {
    try {
        const res = await axios.delete(`${process.env.REACT_APP_BASE_URL}/users/${DatQ1}`)
        dispatch(Slice.actions.deleteInfo(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: Removed,
            type: SuccessMessage
        }));

    } catch (err) {
        dispatch(Slice.actions.usersRequestFailed(err))
    }
}
// to edit user detail
export const GetEditInfo = (id: any) => async (dispatch: any) => {

    try {
        const getdata = await axios.get(`${process.env.REACT_APP_BASE_URL}/users?id=${id}`);
        dispatch(Slice.actions.GetAddEditUser(getdata.data));
    } catch (err) {
        dispatch(Slice.actions.GetAddEditUserError(err))
    }
};
export const clearUserDatainfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearUserData());
};

export const GetUserInfoData = (data) => async (dispatch: any) => {
    dispatch(Slice.actions.AddUserInfoData(data));
};
// pagination
export const setCurrentPage = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.setCurrentPage(data));
};

export const setSearchPage = (data: any, Page: any) => async (dispatch: any) => {
    dispatch(Slice.actions.searchSatus({
        searchText: data,
        page: Page
    }));
};

export const clearSearchPage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearsearchSatus());
};

// clear data
export const clearAlertMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearAlertMessage());
};

export const profileImgStatus = (data) => async (dispatch: any) => {
    dispatch(Slice.actions.selectProfileImageStatus(data));
};
export const profileImg = (data) => async (dispatch: any) => {
    dispatch(Slice.actions.selectProfileImage(data));
};
export const clearUserReset = () => async (dispatch: any) => {
    dispatch(Slice.actions.GetUserReset());
};
export const clearUserResetLocal = () => async (dispatch: any) => {
    dispatch(Slice.actions.updateUserNameReset());
};



export const { GetAddEditUser, ErrorUpdate, showAlertMessage, selectProfileImage } = Slice.actions;
export const selectpflImg = (state) => state.user.profileImage;
export const reducer = Slice.reducer;
export default Slice;